import { Box, BoxProps, styled } from "@mui/material";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import AppStoreBadgeEN from "../assets/img/apple-app-store-badge-en.svg";
import AppStoreBadgeNO from "../assets/img/apple-app-store-badge-no.svg";
import GoogleBadgeEN from "../assets/img/google-play-badge-en.png";
import GoogleBadgeNO from "../assets/img/google-play-badge-no.png";

type BadgeProps = {
	url: string;
};

const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=no.innomar.sunfish.digicatch";
const APP_STORE_URL = "https://apps.apple.com/no/app/digicatch/id1554882043";

function Badge({ url, children }: PropsWithChildren<BadgeProps>) {
	return (
		<Box maxWidth="200px" mx="auto">
			<a href={url} target="_blank" rel="noreferrer">
				{children}
			</a>
		</Box>
	);
}

const BadgeImage = styled("img")`
	max-width: 100%;
	height: auto;
`;

function AppleBadge() {
	const { t, i18n } = useTranslation();
	if (i18n.language === "nb-NO") {
		return (
			<Badge url={APP_STORE_URL}>
				<BadgeImage
					src={AppStoreBadgeNO}
					alt={t("appStore")}
					style={{  marginTop: 0, width: "88%" }}
				/>
			</Badge>
		);
	}

	return (
		<Badge url={APP_STORE_URL}>
			<BadgeImage
				src={AppStoreBadgeEN}
				alt={t("appStore")}
				style={{  marginTop: 0, width: "88%" }}
			/>
		</Badge>
	);
}

function GoogleBadge() {
	const { t, i18n } = useTranslation();
	if (i18n.language === "nb-NO") {
		return (
			<Badge url={GOOGLE_PLAY_URL}>
				<BadgeImage src={GoogleBadgeNO} alt={t("googlePlay")} style={{width: "88%"}} />
			</Badge>
		);
	}

	return (
		<Badge url={GOOGLE_PLAY_URL}>
			<BadgeImage src={GoogleBadgeEN} alt={t("googlePlay")}  style={{width: "88%"}}/>
		</Badge>
	);
}

function AppStoreBadges(props: BoxProps) {
	return (
		<Box {...props} data-testid="app-store-badges" >
				<GoogleBadge />
				<AppleBadge />
		</Box>
	);
}

export default AppStoreBadges;
